<template>
  <div class="ImageDetailsPage">
    <!-- header start -->
    <van-nav-bar title="相册详情" left-arrow fixed :z-index="99" @click-left="onClickLeft" :border="false">
      <template v-if="isSelf" #right>
        <div v-if="isSelf" style="color:white; margin-right:10px;" @click="clickEdit">{{editName}}</div>
        <van-icon name="add-o" @click="clickImageAdd"/>
      </template>
    </van-nav-bar>
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div>
      <Waterfall :gid="gid + ''" :isShow="isShow" />
    </div>
    <div class="details__bottom">
      <van-button round block class="mybtn" :to="{path:'/MemorialHall', query:{id:id}}" replace>返回纪念馆主页</van-button>
    </div>
  </div>
</template>

<script>
  import Waterfall from "@/components/waterfall";
  import { mapGetters, mapState } from "vuex";
  export default {
    data() {
      return {
        gid : "",
        id : "",
        isSelf :false,
        editName : "编辑",
        isShow : false,
      };
    },
    components: {
      Waterfall
    },
    computed: {
      ...mapGetters(["currentToken"])
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1)
      },
      clickImageAdd() {
        this.$router.push('/ImageItemAdd?gid='+this.gid + "&id=" + this.id);
      },
      init(){
        this.getIsSelf();
      },
      getIsSelf() {
        var that = this;
        if(this.currentToken && this.currentToken.isLogin){
          this.$store
            .dispatch({
              type: "getIsSelfMemorialHall",
              id: that.id,
              Mid: "",
            })
            .then(
              res => {
                that.isSelf = res == true;
              },
              err => {}
            );
        }
      },
      clickEdit(){
        var that = this;
        this.isShow = !this.isShow;
        this.editName = this.isShow? "取消" : "编辑";
        

      }
    },
    created() {
      // console.log(this.$route)
      var that = this;
      that.gid = this.$route.query.gid;
      that.id = this.$route.query.id;
      this.init();
    }
    
  };
</script>

<style scoped>
.ImageDetailsPage{
  padding-bottom: 100px;
}
.details__bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  box-sizing: border-box;
  width: 100%;
  padding: 5px 16px;
  background-color: #fff;
}
.details__bottom .mybtn{
  height: 40px;
  line-height: 38px;
}
</style>
